import * as React from 'react';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import assign from 'object-assign';
import { Translate } from '../../../shared/LanguageService';
import { createProduct } from '../actions/ProductActions';
import ProductForm from '../productForm/view/ProductForm';
import { handleError } from '../../../shared/ErrorCatching';
import ConfirmationModal from '../../../components/common/ConfirmationModal';

class CreateProductModal extends React.Component<any, any> {
    constructor(props: any, context: any) {
        super(props, context);

        this.state = {
            product: {
                isDiscontinued: false,
                isVisibleToCustomer: false,
                isPhotographerProduct: false,
                isPhotographerProductPreChoosen: false,
                isPossibleToSplitFromOrder: false,
                bookingCondition: 1,
                shouldUpdateAllPhotographers: false,
                showConfirmModal: false,
                isUploadable: false,
                isPricePropertyOwnerLocked: true,
                deliveryTime: 0
            },
            errors: {},
            creating: false
        };

        this.onChange = this.onChange.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.create = this.create.bind(this);
        this.checkConfirmationModal = this.checkConfirmationModal.bind(this);
        this.yesConfirmation = this.yesConfirmation.bind(this);
        this.noConfirmation = this.noConfirmation.bind(this);
        this.closeConfirmModal = this.closeConfirmModal.bind(this);
    }

    render() {
        return (
            <div>
                <Modal show={true} onHide={this.closeModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {Translate('products/modal/title/create-product')}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <ProductForm
                            product={this.state.product}
                            errors={this.state.errors}
                            productTypes={this.props.productTypes}
                            productProperties={this.props.productProperties}
                            productDeliveryTimes={this.props.productDeliveryTimes}
                            bookingConditions={this.props.bookingConditions}
                            legalEntities={this.props.legalEntities}
                            invoiceProductTypes={this.props.invoiceProductTypes}
                            onChange={this.onChange}
                            sites={this.props.sites}
                            site={this.props.site}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.closeModal}>
                            {Translate('products/modal/footer/button-label/close')}
                        </Button>
                        <Button
                            disabled={this.state.creating}
                            bsStyle="primary"
                            onClick={this.checkConfirmationModal}
                        >
                            {Translate('products/modal/footer/button-label/save')}
                        </Button>
                        {this.state.showConfirmModal && (
                            <ConfirmationModal
                                size="small"
                                closeModal={this.closeConfirmModal}
                                noAction={this.noConfirmation}
                                title={Translate('products/modal/confirm-modal/title')}
                                text={Translate('products/modal/confirm-modal/content')}
                                doButtonLabel={Translate('products/modal/confirm-modal/button/yes')}
                                cancelButtonLabel={Translate(
                                    'products/modal/confirm-modal/button/no'
                                )}
                                do={this.yesConfirmation}
                                doButtonStyle={'default'}
                            />
                        )}
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }

    closeConfirmModal() {
        this.setState({ showConfirmModal: false });
    }

    create() {
        this.setState({ creating: true });
        this.props.actions
            .createProduct(this.state.product)
            .then(() => {
                this.setState({ creating: false });
                this.closeModal();
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    this.setState({ errors: errors, creating: false });
                })
            );
    }

    onChange(product: any) {
        this.setState({ product: product });
    }

    closeModal() {
        this.props.close();
    }

    checkConfirmationModal() {
        if (this.state.product.isPhotographerProductPreChoosen) {
            this.setState({ showConfirmModal: true });
        } else {
            this.create();
        }
    }

    yesConfirmation() {
        let product = this.state.product;
        product.shouldUpdateAllPhotographers = true;
        this.setState({
            product: assign({}, product),
            showConfirmModal: false
        });
        this.create();
    }

    noConfirmation() {
        let product = this.state.product;
        product.shouldUpdateAllPhotographers = false;
        this.setState({
            product: assign({}, product),
            showConfirmModal: false
        });
        this.create();
    }
}

function mapStateToProps(state: any) {
    return {
        products: state.productsResult.products,
        site: state.site
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            createProduct: (product: any) => dispatch(createProduct(product))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateProductModal);
